import { render } from "./BulletinBoardInfomationEdit.vue?vue&type=template&id=07a680d4&scoped=true&ts=true"
import script from "./BulletinBoardInfomationEdit.vue?vue&type=script&lang=ts"
export * from "./BulletinBoardInfomationEdit.vue?vue&type=script&lang=ts"

import "./BulletinBoardInfomationEdit.vue?vue&type=style&index=0&id=07a680d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07a680d4"]])

export default __exports__